'use client';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef, } from 'react';
import * as DialogPrimitive from '@radix-ui/react-dialog';
import { cx } from '../../../internal/cx.js';
import { CloseGlyph } from '../../../internal/icons.js';
import { dismissHandlers } from '../../../internal/dismiss.js';
/**
 * Modal dialog. Focus is trapped inside, Escape closes it, and focus returns
 * to the trigger. Every dialog needs a DialogTitle (visually hidden if
 * necessary) so it has an accessible name.
 */
export const Dialog = DialogPrimitive.Root;
export const DialogTrigger = DialogPrimitive.Trigger;
export const DialogClose = DialogPrimitive.Close;
export const DialogContent = forwardRef(function DialogContent({ size = 'md', closeLabel = 'Close', footer, busy = false, closeOnOutsideClick = true, escapeGuard = true, fullScreenOnPhone = false, onEscapeKeyDown, onInteractOutside, className, children, ...rest }, ref) {
    const guards = dismissHandlers({ busy, closeOnOutsideClick, escapeGuard }, { onEscapeKeyDown, onInteractOutside });
    return (_jsxs(DialogPrimitive.Portal, { children: [_jsx(DialogPrimitive.Overlay, { className: "mn-overlay" }), _jsxs(DialogPrimitive.Content, { ref: ref, ...rest, ...guards, "aria-busy": busy || rest['aria-busy'] || undefined, "data-size": size, "data-busy": busy || undefined, "data-fullscreen-phone": fullScreenOnPhone || undefined, className: cx('mn-dialog', className), children: [children, footer ? _jsx(DialogFooter, { children: footer }) : null, closeLabel ? (_jsx(DialogPrimitive.Close, { className: "mn-dialog__close", "aria-label": closeLabel, disabled: busy || undefined, children: _jsx(CloseGlyph, {}) })) : null] })] }));
});
export function DialogHeader({ className, ...rest }) {
    return _jsx("div", { ...rest, className: cx('mn-dialog__header', className) });
}
export const DialogTitle = forwardRef(function DialogTitle({ className, ...rest }, ref) {
    return (_jsx(DialogPrimitive.Title, { ref: ref, ...rest, className: cx('mn-dialog__title', className) }));
});
export const DialogDescription = forwardRef(function DialogDescription({ className, ...rest }, ref) {
    return (_jsx(DialogPrimitive.Description, { ref: ref, ...rest, className: cx('mn-dialog__description', className) }));
});
export function DialogBody({ className, ...rest }) {
    return _jsx("div", { ...rest, className: cx('mn-dialog__body', className) });
}
export function DialogFooter({ className, ...rest }) {
    return _jsx("div", { ...rest, className: cx('mn-dialog__footer', className) });
}
//# sourceMappingURL=dialog.js.map